module.exports = __webpack_public_path__ + "img/top-right-corner.07dd1426.svg";